module.exports = __webpack_public_path__ + "menu_button.svg?8b939510a35fdae1445cefac338b1799";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_button.svg
// module id = 849
// module chunks = 0